<template>
  <v-dialog v-model="showDeleteDialog" id="buckets-delete-dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn class="mr-2 ml-0 mb-0" v-on="on" color="error" style="min-width: 20px;">
        <v-icon>delete</v-icon>
        <div class="hidden-xs-only">&emsp;Delete Bucket</div>
      </v-btn>
    </template>

    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>Delete Bucket</h2>
      </v-card-title>
      <v-card-text class="ma-0 mt-2 mb-1 pa-0">
        <p>Are you sure you want to delete this bucket?</p>
      </v-card-text>
      <v-card-actions class="ma-0 mt-3 pa-0">
        <v-btn
          @click="deleteBucket"
          id="bucket-delete-dialog-delete-btn"
          color="error"
        >Yes, delete this bucket</v-btn>
        <v-btn
          @click="showDeleteDialog = false"
          id="bucket-delete-dialog-cancel-btn"
          color="secondary"
        >Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    showDeleteDialog: false
  }),
  methods: {
    deleteBucket() {
      this.showDeleteDialog = false
      this.$emit("deleteBucket")
    }
  }
}
</script>
